<template>
	<div class="scrollable phyExService">
		<v-header></v-header>
		<div class="content">
			<div class="breadNav">
		        <div class="nav">
		        	<p>{{$t('m.integralDetails.brankNav')}}</p>
		        	<p>{{companyName}}</p>
		        </div>
		    </div>
		    <div class="all" v-if="quotaDetailsList.transaction!=undefined && quotaDetailsList.transaction.length>0">
		    	<p>{{$t('m.common.surplusAmounts')}}：{{quotaDetailsList.total_amount}}</p>
		    </div>
		    <div class="proList">
		    	<div class="proItem" :key="index" v-for="(item,index) in quotaDetailsList.transaction" v-if="quotaDetailsList.transaction!=undefined && quotaDetailsList.transaction.length>0">
		    		<div class="proName">
		    			<p>{{$t('m.integralDetails.projectName')}}：{{item.project_name}}</p>
		    			<p>{{$t('m.integralDetails.surplusAmount')}}：{{item.amount}}</p>
		    		</div>
		    		<div class="item" :key="indexMsg" v-for="(itemMsg,indexMsg) in item.transactions">
		    			<div class="left">
		    				<p>{{itemMsg.name}}</p>
		    				<p>{{itemMsg.create_time}}</p>
		    			</div>
		    			<p :class="itemMsg.type=='DISTRIBUTE'?'right add':'right reduce'">{{itemMsg.type=='DISTRIBUTE'?'+':'-'}}{{itemMsg.amount}}</p>
		    		</div>
		    		<div class="nay" v-if="item.transactions.length!=undefined && item.transactions.length==0">
		    			<p>—— {{$t('m.integralDetails.noRecord')}} ——</p>
		    		</div>
		    	</div>
		    	<div class="nays" v-if="quotaDetailsList.transaction!=undefined && quotaDetailsList.transaction.length==0">
		    		<img src="../../assets/nayIngeral.png">
	    			<p>{{$t('m.integralDetails.noRecord')}}</p>
	    		</div>
		    </div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
import axios from 'axios'; 
import {mapActions, mapGetters} from 'vuex';
import header from '../common/header.vue'  
import footer from '../common/footer.vue'  
// import Swiper from "swiper"
export default {
	name: 'integralDetails',
	data () {
		return {
			companyName:''
	    }
	},
	components: {
		"v-header": header,
		"v-footer":footer
	},
	created() {
		let _this = this;
		_this.quotaDetails();
		_this.companyName = _this.$route.query.name
  	},
  	methods:{
  		...mapActions( // 语法糖
		    ['message','quotaDetails'] // 相当于this.$store.dispatch('modifyName'),提交这个方法
		    ),
	},
	computed: {
	  ...mapGetters(['quotaDetailsList']) // 动态计算属性，相当于this.$store.getters.resturantName
	},
	mounted(){
		
	}
}
</script>

<style scoped>
.nay{
	width: 1180px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	margin: 30px 0;
}
.nays{
	width: 1180px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 100px 0;
}
.nays img{
	width: 380px;
	height: 214px;
}
.nays p{
	font-size:16px;
	
	font-weight:400;
	color:#999;
	line-height:16px;
	margin-top: 30px;
}
.nay p{
	font-size:14px;
	
	font-weight:400;
	color:#999;
	line-height:14px;
}
.proItem .item{
	width: 1140px;
	margin: 0 auto;
	height: 54px;
	padding: 0 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #dfdfdf;
}
.proItem .item .left{
	display: flex;
}
.proItem .item .left p:nth-child(1){
	font-size:14px;
	
	font-weight:400;
	color:#333;
	line-height:14px;
}
.proItem .item .left p:nth-child(2){
	font-size:14px;
	
	font-weight:400;
	color:#999;
	line-height:14px;
	margin-left: 20px;
}
.proItem .item .right{
	font-size:14px;
	
	font-weight:600;
	line-height:14px;
}
.add{
	color: #E51E26;
}
.reduce{
	color: #333;
}
.proItem .proName{
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 46px;
	background: #f2f2f2;
	padding: 0 20px;
}
.proItem .proName p:nth-child(1){
	font-size:14px;
	
	font-weight:500;
	color:#333;
	line-height:14px;
}
.proItem .proName p:nth-child(2){
	font-size:14px;
	
	font-weight:500;
	color:#e94709;
	line-height:14px;
}
.proItem{
	width: 1180px;
	border: 1px solid #ccc;
	margin: 0 auto;
	margin-bottom: 30px;
}
.all{
	width: 1180px;
	margin: 0 auto;
	height: 50px;
	display: flex;
	align-items: center;
}
.all p{
	font-size:18px;
	
	font-weight:600;
	color:#e94709;
	line-height:16px;
}
.breadNav{
	width: 100%;
	height: 80px;
	border-bottom: 2px solid #EAEAEA;
	display: flex;
	align-items: center;
}
.breadNav .nav{
	width: 1180px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}
.breadNav .nav p:nth-child(1){
	font-size:18px;
	
	font-weight:600;
	color:#333;
	line-height:20px;
}
.breadNav .nav p:nth-child(2){
	font-size:24px;
	
	font-weight:600;
	color:#e94709;
	line-height:24px;
}

</style>



// WEBPACK FOOTER //
// src/components/personal/integralDetails.vue